import { createPortal } from 'react-dom';
import ModalForm from './ModalForm';
import css from './index.module.scss';
import House from './icons/House';
import BMS from './icons/BMS';
import { useGlobal } from '@/utils/useGlobal';
import EfSpec from '@elem/ui/ef-spec';
import EFPicture from '@elem/compCommon/EFPicture';

export default function P({ freeQuote, freeQuoteBack }: any) {
    const { useLang, useEffect, useState, gtm } = useGlobal();
    const { t } = useLang('delta_pro_ultra.launch.detail');
    const [active, setActive] = useState(0);
    const [isClient, setIsClient] = useState(false);

    const items: any[] = [
        {
            icon: <House />,
            title: t('secP_item1_title'),
            desc: t.rich('secP_item1_desc', {
                n: (text: any) => <span className="no-wrap">{text}</span>,
            }),
            tab: t('secP_item1_tab'),
            img: '/responsive/picture/delta-pro-ultra/launch/16_1',
        },
        {
            icon: <BMS />,
            title: t('secP_item2_title'),
            desc: t('secP_item2_desc'),
            tab: t('secP_item2_tab'),
            img: '/responsive/picture/delta-pro-ultra/launch/16_2',
        },
    ];

    const handleChangeTab = (k: number) => {
        setActive(k);
        gtm.push({
            event: 'uaEvent',
            event_name: 'tab_click',
            list_name: 'none',
            button_name: items[k].tab,
        });
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    return (
        <section className={`dpu-detail-P dpu-detail-section ${css['dpu-detail-P']}`}>
            <EfSpec />
            <h2 className="title">{t('secP_title')}</h2>
            <ul className="items">
                {items?.map((item: any, k: number) => (
                    <li className={`item ${active === k ? 'active' : ''}`} key={k}>
                        <div className="text-box">
                            {item?.icon && <div className="item-icon">{item?.icon}</div>}
                            <div className="item-info">
                                {item?.title && <h2 className="item-title">{item?.title}</h2>}
                                {item?.desc && <p className="item-desc">{item?.desc}</p>}
                            </div>
                        </div>
                        <div className="img-box">
                            <EFPicture src={`${item?.img}.jpg`} srcPad={`${item?.img}_768.jpg`} srcMobile={`${item?.img}_768.jpg`} alt={item?.title} />
                            {k === 0 && (
                                <>
                                    <p className="note note1">{t('secP_item1_tip1')}</p>
                                    <p className="note note2">{t('secP_item1_tip2')}</p>
                                    <p className="note note3">{t('secP_item1_tip3')}</p>
                                    <p className="note note4">{t('secP_item1_tip4')}</p>
                                </>
                            )}
                        </div>
                    </li>
                ))}
            </ul>
            <ul className="tabs">
                {items?.map((item: any, k: number) => (
                    <li className={`tab ${active === k ? 'active' : ''}`} key={k} onClick={() => handleChangeTab(k)}>
                        {item?.tab}
                    </li>
                ))}
            </ul>
            {isClient && freeQuote && createPortal(<ModalForm callback={() => freeQuoteBack(false)} />, document.body)}
        </section>
    );
}
